import { Seo } from "@trueskin-web/components"
import { useTranslation } from "@trueskin-web/translations"

import MoneyBack from "../../../components/choose-plan/components/money-back"
import PageHeader from "../../../components/choose-plan/components/page-header"
import FAQs from "../../shared/faqs"
import Products from "../components/products"
import Testimonials from "../components/testimonials"
import { faq, plansV1 } from "../resources"

import Plans from "./plans"

const SubscriptionTiersV1 = () => {
  const { t } = useTranslation()

  return (
    <div sx={{ maxWidth: "468px", mx: "auto" }}>
      <Seo title={t("ChoosePlan.seoTitle")} />

      <PageHeader
        sx={{
          mt: 4,
          columnGap: 5,
          "& h2": {
            lineHeight: "smallerHeading",
          },
        }}
      />

      <Products />

      <Plans resources={plansV1} />

      <MoneyBack sx={{ background: "lightBlue" }} />

      <Testimonials />

      <FAQs
        title="FAQs"
        items={faq}
        sx={{
          mb: 7,
        }}
      />
    </div>
  )
}

export default SubscriptionTiersV1
